import { Route } from '@angular/router';
import { CaptureMeterComponent } from './components/capture-meter/capture-meter.component';


export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./auth/login/login-container.component').then(
        (c) => c.LoginContainerComponent
      ),
  },
  {
    path: 'main',
    loadComponent: () =>
      import('./layout/main.component').then((c) => c.MainComponent),
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./components/dashboard/dashboard.component').then(
            (c) => c.DashboardComponent
          ),
      },
            {
        path: 'scanner',
        loadComponent: () =>
          import('./components/scanners/qr-scanner-dialog').then(
            (c) => c.QrScannerSetupComponent
          ),
      },
      {
        path: 'meter-list',
        loadComponent: () =>
          import(
            './components/tenant-meter-list/tenant-meter-list.component'
          ).then((c) => c.TenantMeterListComponent),
      },
      {
        path: 'scanner',
        loadComponent: () =>
          import('./components/scanners/scan-container.component').then(
            (c) => c.ScanContainerComponent
          ),
      },
      {
        path: 'scanner-a',
        loadComponent: () =>
          import('./components/scanners/scanner-a/scanner-a.component').then(
            (c) => c.ScannerAComponent
          ),
      }, {
        path: 'scanner-b',
        loadComponent: () =>
          import('./components/scanners/scanner-b/scanner-b.component').then(
            (c) => c.ScannerBComponent
          ),
      },
      {
        path: 'scanner-c',
        loadComponent: () =>
          import('./components/scanners/scanner-c/scanner-c.component').then(
            (c) => c.ScannerCComponent
          ),
      },
      {
        path: 'scanner-d',
        loadComponent: () =>
          import('./components/scanners/scanner-d/scanner-d.component').then(
            (c) => c.ScannerDComponent
          ),
      },
      {
        path: 'capture',
        loadComponent: () => Promise.resolve(CaptureMeterComponent)
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./components/profile/profile.component').then(
            (c) => c.ProfileComponent
          ),
      },
      {
        path: 'sync',
        loadComponent: () =>
          import(
            './components/sync-meter-readings/sync-meter-readings.component'
          ).then((c) => c.SyncMeterReadingsComponent),
      },
    ],
  },
  { path: '**', redirectTo: 'login' }
];
